import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const FourBitAdderSubtractor = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="4-bit Adder and Subtractor"
    videos={[
      "https://www.youtube.com/embed/lqN8xLTtdaA?si=EBA9FgsALrecx3qB",
      "https://www.youtube.com/embed/J7gPUP0aRug?si=HL-ZIEC_y5Pd4X5j",
      "https://www.youtube.com/embed/n2hxJqRqD3Q?si=rz53apzB0bP0EWTV",
      "https://www.youtube.com/embed/hpd5r4UkI9k?si=MwfC-JLhCG8PZ-hW",
      "https://www.youtube.com/embed/Xz8Ap24bK8c?si=t-oO4CQqJcpNZCMI",
      "https://www.youtube.com/embed/xIv7YVyDNdE?si=jYHb_QCh4Xj5JFhB"
    ]}
    takeaways={[]}
    questions={[
      "1) Write the Verilog HDL for an 8-bit adder/subtractor circuit using behavioural model along with test bench",
      "2) Write a Verilog Code for a circuit which performs both 4-bit addition and subtraction and draw the logic diagram as well",
      "3) Write a Verilog Code for a circuit which performs both 4-bit addition and subtraction and draw the logic diagram as well"
    ]}
    exampleVideos={[]}
  />
);
}

export default FourBitAdderSubtractor;
